import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-about-us",
  "use": "icon-about-us-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-about-us\"><defs><style type=\"text/css\"></style></defs><path d=\"M16 1008c-8-8-16-16-16-24 0-24 24-40 56-40h24V160l24-16c8-8 112-40 216-80 192-64 200-64 216-48 16 8 16 24 16 472v456h80V664c0-280 0-288 16-296 16-16 32-8 136 16 72 16 136 40 144 48l16 8v504h24c48 0 72 40 40 64-8 16-56 16-496 16-464 0-488 0-496-16z m848-296v-40H704v32c0 24 0 40 8 40 0 8 40 8 80 8h72v-40z m-584-64v-40H160v80h120v-40z m192 0v-40h-56l-56 8-8 32v40h120v-40z m392-96v-40H712v80h152v-40z m-584-56v-40l-64-8h-56v88h120v-40z m192-8v-40h-56l-56 8-8 24c0 56 0 56 64 56h56v-48zM280 336v-40H160v80h120v-40z m192 0v-40H352v32c0 24 0 40 8 40 0 8 24 8 56 8h56v-40z\" fill=\"#2c2c2c\" p-id=\"6291\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/about-us.svg
// module id = tCfw
// module chunks = 0